import _ from 'lodash';

// objFilter({a: 1, b: -1, c: -2}, (k, v) => k == 'b' || v > 0)
// { a: 1, b: -1 }
export function objFilter<Obj extends Record<string, any>>(
  obj: Obj,
  filterFn: (k: keyof Obj, v: Obj[keyof Obj]) => boolean
): Partial<Obj> {
  return Object.fromEntries(
    Object.entries<Obj[keyof Obj]>(obj).filter(([k, v]) => filterFn(k, v))
  ) as Partial<Obj>;
}

export const omitId = (
  values: ((unknown & { _id?: string }) | (unknown & { id?: string }))[]
) => values?.map(value => _.omit(value, ['_id']));
